import { jsx as _jsx } from "react/jsx-runtime";
import { useClassName } from '../../hooks';
import './Space.scss';
/**
 * Wrapper component used to add space between children elements.
 */
export const Space = ({ size = 'md', direction = 'horizontal', children }) => {
    const className = useClassName({ name: 'space', prefixed: true }, size, direction);
    return _jsx("div", { className: className, children: children });
};
